module.exports = __webpack_public_path__ + "img/z_08_lawless-capture.12e80c8b.jpg";